<template>
  <div class="calendar-panel">
    <button
      class="close-button"
      @click="$emit('close')"
    >
      <CloseIcon />
    </button>
    <p>
      <strong>{{ $config.common.reminder.title }}</strong>
      <span>{{ $config.common.reminder.text }}</span>
    </p>
    <ul>
      <li>
        <a
          :href="calendarLinks.google"
          target="_blank"
          rel="noopener"
        >
          <div class="common-picto-google" />
          <span>Google</span>
        </a>
      </li>
      <li>
        <a
          :href="calendarLinks.outlook"
          target="_blank"
          rel="noopener"
        >
          <div class="common-picto-outlook" />
          <span>Outlook</span>
        </a>
      </li>
      <li>
        <a
          :href="calendarLinks.ical"
          target="_blank"
          rel="noopener"
        >
          <div class="common-picto-ical" />
          <span>iCal</span>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import CloseIcon from '@/assets/images/common/icons/close.svg?inline';
import TimerMixin from '@/mixins/TimerMixin.vue';
import { DateTime } from 'luxon';

const {
  google, outlook, ics,
} = require('calendar-link');

export default {
  name: 'CalendarPanel',
  components: {
    CloseIcon,
  },
  mixins: [TimerMixin],
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    calendarEvent() {
      const vars = {
        value: this.product.value,
        metal: this.$config.common.metal[this.product.metal],
        collection: this.$getCollectionById(this.product.collection).genie,
        link: `${window.location.origin}/${this.product.collection.id || this.product.collection}/${this.product.shortId}`,
      };
      const title = this.$config.common.reminder.event.title.format(vars);
      const description = this.$config.common.reminder.event.description.format(vars);
      return {
        title,
        description,
        location: this.$config.common.reminder.event.location,
        busy: false,
        start: this.calendarDate,
        url: `${window.location.origin}/${this.product.collection.id || this.product.collection}/${this.product.shortId}`,
        allDay: true,
      };
    },
    calendarLinks() {
      return {
        google: google(this.calendarEvent),
        outlook: outlook(this.calendarEvent),
        ical: ics(this.calendarEvent),
      };
    },
    calendarDate() {
      const date = this.product.subscription && this.product.subscription.startDate
        ? this.product.subscription.startDate
        : this.product.launchDate;
      if (!date) return null;
      // Return ISO string for the date at noon (12:00)
      return DateTime.fromISO(date).set({
        hour: 12, minute: 0, second: 0, millisecond: 0,
      }).toISO();
    },
  },
};
</script>
<style lang="stylus" scoped>
.calendar-panel {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: black;
  border-radius: 10px;
  border: 1px solid transparent;
  padding: 15px;
  cursor: default;

  .close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    background: none;
    border: none;
    padding: 5px;
    cursor: pointer;

    svg, svg *, svg * *{
      width: 15px;
      height: 15px;
      stroke: var(--main-color);
    }
  }

  p {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1.2

    font-size: 15px;

    strong {
      font-weight: bold;
      font-size: 18px;
    }

  }

  ul {
    margin-top: 10px;
    display: flex;
    gap: 15px;
    list-style: none;
    justify-content: space-around;
    font-size: 13px;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      a {

        &:hover {
          div {
            border: 1px solid var(--main-color);
            transform: scale(1.1);
          }
        }

        div {
          border: 1px solid rgba(229, 238, 247, 1);
          border-radius: 50%;
          width: 58px;
          height: @width;
          box-sizing: content-box;
          background-position: center center;
          transition: all 0.3s ease;
          margin-bottom: 5px;
        }
      }
    }
  }

}
</style>
